export type CityNeighborhoods = {
  city: string;
  neighborhoods: string[];
};

export const parseZone = (zone: string) => {
  const firstDashIndex = zone.indexOf("-");
  if (firstDashIndex === -1) return { city: zone, neighborhood: "" };

  return {
    city: zone.substring(0, firstDashIndex),
    neighborhood: zone.substring(firstDashIndex + 1),
  };
};

export const compactCitySelections = (
  selectedZones: string[],
  cityNeighborhoods: CityNeighborhoods[]
) => {
  const zoneSet = new Set(selectedZones);

  cityNeighborhoods.forEach((cityData) => {
    const cityZone = cityData.city;
    const cityNeighborhoodZones = cityData.neighborhoods.map((n) => `${cityZone}-${n}`);

    if (zoneSet.has(cityZone)) {
      cityNeighborhoodZones.forEach((zone) => zoneSet.delete(zone));
      return;
    }

    if (
      cityNeighborhoodZones.length > 0 &&
      cityNeighborhoodZones.every((zone) => zoneSet.has(zone))
    ) {
      cityNeighborhoodZones.forEach((zone) => zoneSet.delete(zone));
      zoneSet.add(cityZone);
    }
  });

  return Array.from(zoneSet);
};

export const normalizeStoredZones = (
  zones: string[],
  cityNeighborhoods: CityNeighborhoods[]
) => {
  const normalizedZones = new Set<string>();

  zones.forEach((zone) => {
    if (zone.includes("-")) {
      const { city, neighborhood } = parseZone(zone);
      const cityData = cityNeighborhoods.find((c) => c.city === city);
      if (cityData?.neighborhoods.includes(neighborhood)) {
        normalizedZones.add(`${city}-${neighborhood}`);
      }
      return;
    }

    const cityData = cityNeighborhoods.find((c) => c.city === zone);
    if (cityData) {
      normalizedZones.add(zone);
      return;
    }

    const cityByNeighborhood = cityNeighborhoods.find((c) => c.neighborhoods.includes(zone));
    if (cityByNeighborhood) {
      normalizedZones.add(`${cityByNeighborhood.city}-${zone}`);
    }
  });

  return compactCitySelections(Array.from(normalizedZones), cityNeighborhoods);
};
